import { FunctionalComponent, h } from 'preact';

import { IconProps } from 'ui/icons/icon';

export const LinkIcon: FunctionalComponent<IconProps> = (props) => {
	const { size = 18, fill = '#BFBFBF' } = props;

	return (
		<svg width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M7.5 9.74997C7.82209 10.1806 8.23302 10.5369 8.70491 10.7947C9.17681 11.0525 9.69863 11.2058 10.235 11.2442C10.7713 11.2826 11.3097 11.2053 11.8135 11.0173C12.3173 10.8294 12.7748 10.5353 13.155 10.155L15.405 7.90497C16.0881 7.19772 16.4661 6.25046 16.4575 5.26722C16.449 4.28398 16.0546 3.34344 15.3593 2.64815C14.664 1.95287 13.7235 1.55849 12.7403 1.54995C11.757 1.5414 10.8098 1.91938 10.1025 2.60247L8.8125 3.88497"
				stroke={fill} stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
			<path
				d="M10.5001 8.24992C10.1781 7.81933 9.76713 7.46304 9.29524 7.20522C8.82334 6.9474 8.30152 6.79409 7.76516 6.75567C7.2288 6.71726 6.69046 6.79465 6.18664 6.98259C5.68282 7.17053 5.22531 7.46462 4.84515 7.84492L2.59515 10.0949C1.91206 10.8022 1.53408 11.7494 1.54262 12.7327C1.55117 13.7159 1.94555 14.6565 2.64083 15.3517C3.33611 16.047 4.27666 16.4414 5.2599 16.45C6.24313 16.4585 7.19039 16.0805 7.89765 15.3974L9.18015 14.1149"
				stroke={fill} stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
		</svg>
	);
};
